export default __webpack_public_path__ + "static/media/background-yellow.fa54f03c.jpg";